import { __assign } from "tslib";
;
;
;
export var NotificationChannels;
(function (NotificationChannels) {
    NotificationChannels[NotificationChannels["EMAIL"] = 10] = "EMAIL";
    NotificationChannels[NotificationChannels["IN_APP"] = 20] = "IN_APP";
})(NotificationChannels || (NotificationChannels = {}));
export var createIntegrationsApi = function (baseUrl, http) {
    var apiUrl = baseUrl + '/integrations';
    var installedIntegrationsUrl = apiUrl + "/installed";
    var integrationUrl = function (id) { return apiUrl + "/" + id; };
    return {
        getIntegrations: function () {
            return http.get(apiUrl);
        },
        getIntegration: function (dto) {
            return http.get(integrationUrl(dto.id));
        },
        getInstalled: function () {
            return http.get(installedIntegrationsUrl);
        },
        addIntegration: function (dto) {
            return http.post(integrationUrl(dto.id), {});
        },
        removeIntegration: function (dto) {
            return http.delete(integrationUrl(dto.id));
        },
        setSetupComplete: function (dto) {
            return http.post(integrationUrl(dto.id) + "/setup/complete", {});
        },
        sendNotification: function (dto) {
            return http.post(integrationUrl(dto.id) + "/notifications", __assign(__assign({}, dto), { id: undefined }));
        },
        sign: function (dto) { return http.post(integrationUrl(dto.id) + "/payload/sign", __assign(__assign({}, dto), { id: undefined })); }
    };
};
//# sourceMappingURL=index.js.map